<template>
    <section>
        <o-field label="Left">
            <o-skeleton width="30%" position="left" />
        </o-field>

        <o-field label="Center">
            <o-skeleton width="30%" position="centered" />
        </o-field>

        <o-field label="Right">
            <o-skeleton width="30%" position="right" />
        </o-field>
    </section>
</template>
